import { useEffect } from "react";

type ActionNoticeProps = {
  message: string;
  onClose: () => void;
  tone?: "default" | "accent";
};

export default function ActionNotice({ message, onClose, tone = "default" }: ActionNoticeProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed inset-x-0 bottom-6 z-[60] flex justify-center px-4 pointer-events-none">
      <div
        className={`flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm animate-fade-up border ${
          tone === "accent"
            ? "bg-accent-500 text-background-50 border-accent-400"
            : "bg-background-200 text-foreground-950 border-background-300"
        }`}
      >
        <i className="ri-check-line text-base"></i>
        <span>{message}</span>
      </div>
    </div>
  );
}